import gql from "graphql-tag";

export function languageListQuery(params) {
    return {
        query: gql`
            query($searchText: String) {
                result: languages(searchText: $searchText) {
                    id
                    name
                    code
                }
            }
        `,
        variables: params,
    };
}
